import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Image from 'global/Image';
import ImageSlider from 'global/ImageSlider';
import { useMemo } from 'react';
import { StreamPostData } from '../../../../@types/stream';
import { InsightContainer, InsightWrapper, PostInsightContainer, PostInsightFreeze, SModalInsight } from './styled';
import { ContentWrapper, TextContainer } from '../Post/styled';
import PollingContainer from '../PollingContainer';
import TargetPriceContainer from '../TargetPriceContainer';
import TextContent from '../TextContent';
import DocumentContainer from '../Post/DocumentContainer';
import Header from '../Post/Header';
import TitleContent from '../Post/TitleContent';
import YoutubePlayer from '../Post/YoutubePlayer';

interface ModalInsightProps {
  post: StreamPostData;
  [key: string]: any;
}

function ModalInsight({ post, ...props }: ModalInsightProps) {
  const {
    content,
    content_original,
    images,
    attachment,
    polling,
    target_price,
    mask_html,
    title,
    titleurl,
    images_data,
    image_frame_type,
    analytics,
    is_author: isAuthor,
  } = post;

  const imagesData = useMemo(() => {
    let listImage = images?.length > 0 && images[0] !== ''
      ? images.map((i) => ({ image: i }))
      : [];

    listImage = listImage.filter((i) => {
      const exist = images_data.find((img) => img.image === i.image);
      return !exist;
    });

    listImage = [...listImage, ...images_data];
    return listImage;
  }, [post]);

  const isHaveImage = Boolean(imagesData?.length > 0 && imagesData[0]?.image);
  const totalEngagement = useMemo(() => {
    let total = 0;
    if (analytics?.engagement) {
      Object.keys(analytics?.engagement).forEach((key) => {
        total += analytics?.engagement[key];
      });
    }
    return total;
  }, [post]);

  return (
    <SModalInsight
      {...props}
      title={(
        <Text
          size="18px"
          family="bold"
          align="center"
          // @ts-expect-error
          pt="16px"
        >
          Insights
        </Text>
      )}
      centered
      footer={null}
      width={800}
    >
      <InsightWrapper>
        <PostInsightContainer id="post-detail">
          <PostInsightFreeze />
          <Header post={post} isLoggedIn={false} withMenu={false} />
          <ContentWrapper>
            {polling?.length ? (
              <PollingContainer post={post} isSinglePost />
            ) : (
              <>
                <TextContainer>
                  {title && titleurl && (
                    <TitleContent title={title} titleUrl={titleurl} />
                  )}
                  <TextContent content={content} maskedHtml={mask_html} />
                  {post.newsfeed_source && (
                    <Flex>
                      <Image
                        alt={post.newsfeed_label}
                        src={`/${post.newsfeed_img}`}
                        style={{ width: '16px', marginRight: '8px' }}
                      />
                      <Text size="12px">{post.newsfeed_label}</Text>
                    </Flex>
                  )}
                </TextContainer>

                {isHaveImage ? (
                  <ImageSlider images={imagesData} frameType={image_frame_type} />
                ) : (
                  <YoutubePlayer content={content_original} />
                )}

                {attachment?.length > 0 && (
                  <DocumentContainer documents={attachment} />
                )}

                {target_price?.length > 0 && (
                  <TargetPriceContainer
                    targetPrice={target_price[0]}
                    postid={post.postid}
                    isAuthor={isAuthor}
                  />
                )}
              </>
            )}
          </ContentWrapper>

        </PostInsightContainer>
        <InsightContainer id="insight-detail">
          <Flex justify="space-between" padding="5px 0">
            <Text size="22px" weight="bold">
              Impressions
            </Text>
            <Text size="22px" weight="bold">
              {analytics?.impressions || 0}
            </Text>
          </Flex>
          <Flex justify="space-between" padding="5px 0">
            <Text size="22px" weight="bold">
              Total Engagements
            </Text>
            <Text size="22px" weight="bold">
              {totalEngagement}
            </Text>
          </Flex>
          <Flex justify="space-between" padding="5px 0">
            <Text>Like</Text>
            <Text>{analytics?.engagement?.like || 0}</Text>
          </Flex>
          <Flex justify="space-between" padding="5px 0">
            <Text>Reply</Text>
            <Text>{analytics?.engagement?.reply || 0}</Text>
          </Flex>
          <Flex justify="space-between" padding="5px 0">
            <Text>Share</Text>
            <Text>{analytics?.engagement?.share || 0}</Text>
          </Flex>
          <Flex justify="space-between" padding="5px 0">
            <Text>Post Clicks</Text>
            <Text>{analytics?.engagement?.sign_click || 0}</Text>
          </Flex>
          <Flex justify="space-between" padding="5px 0">
            <Text>Profile Views</Text>
            <Text>{analytics?.engagement?.profile_view || 0}</Text>
          </Flex>
        </InsightContainer>
      </InsightWrapper>
    </SModalInsight>
  );
}

export default ModalInsight;
